import axios from 'axios';
import baseUrl from './Base_Url/baseUrl';
import { showToast } from './toastService';
import { getToken, clearAuth } from 'constants/helper/authStorage';

const axiosInstance = axios.create({
  baseURL: baseUrl,
  headers: {
    'Content-Type': 'application/json',
  },
});

let isUnauthorizedToastShown = false; // flag to track if the toast has been shown

const resetUnauthorizedToast = () => {
  isUnauthorizedToastShown = false;
};

// Request interceptor to add token
axiosInstance.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error),
);

// Response interceptor
const responseInterceptor = (response) => {
  return response;
};

const errorInterceptor = (error) => {
  if (error.response) {
    const { status } = error.response;

    if (status === 401 && !isUnauthorizedToastShown) {
      isUnauthorizedToastShown = true;
      clearAuth();
      showToast('🔒 Session expired. Please login again.');
      
      // Use window.location as we're outside React components
      window.location.href = '/auth/sign-in';
      
      setTimeout(resetUnauthorizedToast, 5000);
    }

    if (status === 403) {
      showToast('❌ You are not allowed to access this page!');
      window.location.href = '/admin/dashboard';
    }
  }

  return Promise.reject(error);
};

// Apply to instance
axiosInstance.interceptors.response.use(responseInterceptor, errorInterceptor);

// Apply globally to axios object as well, since many files use it directly
axios.interceptors.response.use(responseInterceptor, errorInterceptor);

export default axiosInstance;
